import React, { Component, Suspense, useEffect } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/style.scss';
import {
   BrowserRouter, Navigate, Route, Routes, useNavigate
} from 'react-router-dom';

import Home from './views/home';
import Crash from './views/crash';
import Transaction from './views/transaction';
import Mines from './views/mines';
import Kyc from './views/kyc';
import Security from './views/security';
import Contactus from './views/contactus';
import Withdraw from './views/withdraw';
import Deposit from './views/deposit';
import Faq from './views/faq';
import Pagenotfound from './views/pagenotfound';
import Myprofile from './views/myprofile';
import Editprofile from './views/editprofile';
import Privacy from './views/privacy';
import Terms from './views/terms';
import Statistics from './views/statistics';
import Bankdetails from './views/bankdetails';
import Aboutus from "../src/views/Aboutus/index";

import { useCustomizeContext } from './context';
import VerificationCode from "./views/VerificationMail/index"
import VerificationForget from "./views/VerificationForget/index";




import { useDispatch } from "react-redux";
import { getSiteInfo } from "./Features/SiteSettings/siteSettingSlice";
import LinkEmailVerify from './views/LinkEmailVerify';
import { useTranslation, I18nextProvider } from "react-i18next";
import 'react-loading-skeleton/dist/skeleton.css'
import ComingSoon from './views/ComingSoon';

import { getUserDetails } from "../src/Features/SiteSettings/siteSettingSlice.js";
import { logout } from "../src/Features/Register/registerSlice";


import io from 'socket.io-client';
import helper from './Helper';


const App = (props) => {

   const { t, i18n } = useTranslation();

   let socketURL = helper?.SocketBackendURL();


   const {
      loader: {
         loading, setLoading
      },

      userAuthToken: {
         userToken, setUserToken
      },
      siteInformation: {
         setContact,
         setCopyrightstext,
         setEmail,
         setFacebook,
         setInstagram,
         setLinkedIn,
         setDiscord,
         setSiteLink,
         setGithub,
         setTwitter,
         setYoutube,
         setBusinessemail,
         setMetakeyword,
         setMetadescription,
         setLogo,
         setFavicon,
         setDarkThemeLogo,
         setCopyrightstextPt,
      },

      languageContext: {
         language, setLanguage,
      }
   } = useCustomizeContext();

   let dispatch = useDispatch();


   useEffect(() => {
      const socket = io.connect(socketURL);
      socket.on("usersuspension", async function (data) {
         if (data?.status === false) {
            let res = await dispatch(getUserDetails());
            if (res?.status === true && res?.data?.details?.user_active_status === true) {
               let logoutRes = await dispatch(logout());
               localStorage.removeItem("loginToken");
               localStorage.removeItem("currency");
               sessionStorage.removeItem("isActive");
               setUserToken("");
               setLoading(false);
               window.location.href = "/";


            }
            else {
               setLoading(false);
            }
         }
      })
      return () => {
         socket.disconnect();
      }
   }, []);

   useEffect(() => {
      setUserToken(localStorage.getItem("loginToken"));
      sessionStorage.setItem("isActive", true);
   }, [userToken]);


   useEffect(() => {
      let data = {
         "language": language?.value,
      }
      getSiteDetails(data);
   }, [language]);

   const getSiteDetails = async (data) => {
      setLoading(true);
      let res = await dispatch(getSiteInfo(data));
      setTimeout(() => {
         if (res?.status) {
            setContact(res?.data?.Contact);
            setCopyrightstext(res?.data?.Copyrightstext);
            setCopyrightstextPt(res?.data?.copyRightsPt);
            setEmail(res?.data?.Email);
            setFacebook(res?.data?.Facebook);
            setInstagram(res?.data?.Instagram);
            setLinkedIn(res?.data?.LinkedIn);
            setDiscord(res?.data?.Discord);
            setSiteLink(res?.data?.SiteLink);
            setGithub(res?.data?.Github);
            setTwitter(res?.data?.Twitter);
            setYoutube(res?.data?.Youtube);
            setBusinessemail(res?.data?.businessemail);
            setMetakeyword(res?.data?.metakeyword);
            setMetadescription(res?.data?.metadescription);
            setFavicon(res?.data?.favicon);
            setLogo(res?.data?.sitelogo);
            setDarkThemeLogo(res?.data?.darkLogo);
            document.getElementById('appFavicon').setAttribute('href', res?.data?.favicon);
            document.querySelector("title").text = res?.data?.SiteName;
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);
   }

   useEffect(() => {
      const todosString = localStorage.getItem("loginToken");
      if (todosString) {
         setUserToken(todosString);
         sessionStorage.setItem("isActive", true);
      }
      function storageEventHandler(event) {
         if (event.key === "loginToken") {
            setUserToken(event.newValue);
         }
      }
      window.addEventListener("storage", storageEventHandler);
      return () => {
         window.removeEventListener("storage", storageEventHandler);
      };
   }, []);

   function PrivateRoute({ children }) {

      const navigate = useNavigate();

      if (!userToken) {
         window.location.href = "/"

      }

      // authorized so return child components
      return children;

   }




   return (
      <React.Fragment>
         <div className={loading ? 'loading' : 'd-none'}>
            <img src='https://mir-s3-cdn-cf.behance.net/project_modules/disp/35771931234507.564a1d2403b3a.gif'
               className='img-fluid' width={80} />
         </div>
         <BrowserRouter>
            <Routes history={props.history}>
               <Route path='/' element={<Home />} />
               <Route path='/crash' element={<Crash />} />
               <Route path='/activation_code/:id' element={<VerificationCode />} />
               <Route path='/resetCode/:id' element={<VerificationForget />} />
               <Route path='/transaction' element={<Transaction />} />
               <Route path='/about' element={<Aboutus />} />
               <Route path='/mines' element={<Mines />} />
               <Route path='/kyc' element={<Kyc />} />
               <Route path='/security' element={<Security />} />
               <Route path='/contactus' element={<Contactus />} />
               <Route path='/withdraw' element={<Withdraw />} />
               <Route path='*' element={<Pagenotfound />} />
               <Route path='/deposit' element={<Deposit />} />

               <Route path='/faq' element={<Faq />} />
               <Route path='/myprofile' element={<Myprofile />} />
               <Route path='/editprofile' element={
                  <Editprofile />
               } />
               <Route path='/privacy' element={<Privacy />} />
               <Route path='/terms' element={<Terms />} />
               <Route path='/statistics' element={<Statistics />} />
               <Route path='/link_mail/:id' element={<LinkEmailVerify />} />
               <Route path='/comingsoon' element={<ComingSoon />} />
            </Routes>
         </BrowserRouter>
      </React.Fragment>
   );
}

export default App;
